import af from './af.json';
import am from './am.json';
import ar from './ar.json';
import az from './az.json';
import bg from './bg.json';
import bn from './bn.json';
import bs from './bs.json';
import ca from './ca.json';
import cs from './cs.json';
import da from './da.json';
import de from './de.json';
import el from './el.json';
import en from './en.json';
import es from './es.json';
import et from './et.json';
import eu from './eu.json';
import fa from './fa.json';
import fi from './fi.json';
import fr from './fr.json';
import gl from './gl.json';
import he from './he.json';
import hi from './hi.json';
import hr from './hr.json';
import hu from './hu.json';
import id from './id.json';
import it from './it.json';
import ja from './ja.json';
import ka from './ka.json';
import ko from './ko.json';
import lt from './lt.json';
import lv from './lv.json';
import mk from './mk.json';
import ms from './ms.json';
import my from './my.json';
import nb from './nb.json';
import nl from './nl.json';
import pl from './pl.json';
import pt from './pt.json';
import ro from './ro.json';
import ru from './ru.json';
import sk from './sk.json';
import sl from './sl.json';
import sq from './sq.json';
import sr from './sr.json';
import sv from './sv.json';
import sw from './sw.json';
import ta from './ta.json';
import th from './th.json';
import tl from './tl.json';
import tr from './tr.json';
import uk from './uk.json';
import ur from './ur.json';
import uz from './uz.json';
import vi from './vi.json';
import zh from './zh.json';

const languages = {
	af,
	am,
	ar,
	az,
	bg,
	bn,
	bs,
	ca,
	cs,
	da,
	de,
	el,
	en,
	es,
	et,
	eu,
	fa,
	fi,
	fr,
	gl,
	he,
	hi,
	hr,
	hu,
	id,
	it,
	ja,
	ka,
	ko,
	lt,
	lv,
	mk,
	ms,
	my,
	nb,
	nl,
	pl,
	pt,
	ro,
	ru,
	sk,
	sl,
	sq,
	sr,
	sv,
	sw,
	ta,
	th,
	tl,
	tr,
	uk,
	ur,
	uz,
	vi,
	zh
};

export default languages;
